// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Theme } from '@mui/material/styles';

export const dataGridSx = (theme: Theme, hasRowClick?: boolean) => ({
  border: 0,

  '.MuiDataGrid-columnHeaders': {
    border: 0,
  },
  '.MuiDataGrid-virtualScroller': {
    boxShadow: `inset 0 0 0 1px ${theme.palette.divider}`,
    borderRadius: 1,
    minHeight: '52px',
  },
  '.MuiDataGrid-columnHeaderTitle': {
    color: 'secondary.main',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: theme.typography.caption.fontSize,
  },
  '.MuiDataGrid-footerContainer': {
    borderTop: 0,
  },
  '.MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '.MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  // Removes horizontal scrollbar.
  // Cell has a nested container element with no predefined class to easily overwrite.
  '.MuiDataGrid-cell > *': {
    scrollbarWidth: 'none',
  },
  // Add this block to target the row.
  '.MuiDataGrid-row': {
    cursor: hasRowClick ? 'pointer' : undefined,
  },
});
